import styled from 'styled-components/macro'

import { IconAttention, IconClock } from '@loadsmart/icons'
import { IconButton, Layout } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const ModalContentWrapper = styled.div`
  min-height: 500px;
  ${screen.md} {
    min-width: 372px;
  }
`

export const Content = styled(Layout.Stack)`
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 500px;
`

export const BidInputWrapper = styled.div`
  display: flex;
  flex-direction: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-weight: 500;
  font-size: ${getToken('font-size-1')};
`

const space2XL = getToken('space-2xl')

export const StyledIconButton = styled(IconButton)`
  flex-shrink: 0;
  background: transparent;
  padding: ${getToken('space-s')};
  color: ${getToken('color-primary')};
  border: 1px solid ${getToken('color-neutral')};
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 100ms, background-color 120ms, color 120ms;
  user-select: none;

  :hover {
    opacity: 0.7;
  }
  :active {
    color: ${getToken('color-neutral-light')};
    background-color: ${getToken('color-primary')};
    border-color: ${getToken('color-neutral-light')};
  }
`

function hasErrorStyle(error) {
  return getToken(error ? 'color-danger' : 'color-neutral-dark')
}

export const StyledPriceInput = styled.input`
  width: 12.5rem;
  padding-bottom: ${getToken('space-xs')};
  color: ${({ hasError }) => hasErrorStyle(hasError)};
  font-weight: bold;
  font-size: ${space2XL};
  text-align: center;
  background: none;
  border: none;
  border-bottom: 1px solid ${({ hasError }) => hasErrorStyle(hasError)};
  outline: none;
  transition: color 100ms, border-bottom-color 100ms;
  resize: none;
`

const space3XL = getToken('space-3xl')

export const ErrorIcon = styled(IconAttention)`
  display: block;
  width: ${space3XL};
  height: ${space3XL};
  margin: 0 auto 20px;
`

const spaceL = getToken('space-l')

export const PendingIcon = styled(IconClock)`
  display: block;
  width: ${space3XL};
  height: ${space3XL};
  margin: 0 auto ${spaceL};
`
